/**
 * Global tooltip manager to ensure only one tooltip is visible at a time
 */
class TooltipManager {
  private currentTooltipId: string | null = null;

  private closeCallbacks: Map<string, () => void> = new Map();

  /**
   * Register a tooltip and its close callback
   */
  register(id: string, closeCallback: () => void): void {
    this.closeCallbacks.set(id, closeCallback);
  }

  /**
   * Unregister a tooltip
   */
  unregister(id: string): void {
    this.closeCallbacks.delete(id);
    if (this.currentTooltipId === id) {
      this.currentTooltipId = null;
    }
  }

  /**
   * Open a tooltip, closing any previously open tooltip
   */
  open(id: string): void {
    // Close the currently open tooltip if it's different
    if (this.currentTooltipId && this.currentTooltipId !== id) {
      const closeCallback = this.closeCallbacks.get(this.currentTooltipId);
      if (closeCallback) {
        closeCallback();
      }
    }
    this.currentTooltipId = id;
  }

  /**
   * Close a tooltip
   */
  close(id: string): void {
    if (this.currentTooltipId === id) {
      this.currentTooltipId = null;
    }
  }

  /**
   * Check if a tooltip is currently open
   */
  isOpen(id: string): boolean {
    return this.currentTooltipId === id;
  }

  /**
   * Get the currently open tooltip ID
   */
  getCurrentTooltipId(): string | null {
    return this.currentTooltipId;
  }
}

// Export singleton instance
export const tooltipManager = new TooltipManager();
